import React, { useEffect } from 'react';
import { FileBox, MCButton, MCText, Spinner, View } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { scssVariables } from 'src/helpers';
import { remCss, remFontCss } from 'src/components/mobile/utils';
import moment from 'moment/moment';
import SVGIcon from 'src/components/svg';
import galleryModel from '../galleryModel';
import MCVirtuoso from 'src/components/complex/MCVirtuoso';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { MediaGroup } from 'src/components/complex';

export const GalleryTab = ({ clinic }) => {
  galleryModel.use();

  useEffect(() => {
    galleryModel.initLoad(clinic, true);
  }, [clinic]);

  const items = galleryModel.items();
  const loading = galleryModel.refreshing();

  const gallery = {
    main: clinic?.gallery?.main,
    tags: Object.keys(clinic?.gallery?.tags || {})
  };
  const hasMain = !!gallery?.main?.title;

  if (!gallery.tags?.length && !hasMain) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white'
        }}
      >
        <MCText
          label={LANG_CONST.text.no_results_yet}
          size={20}
          weight={500}
          textLight
          remFontCss={remFontCss}
        />
      </View>
    );
  }
  return (
    <View style={{ flex: 1, padding: remCss(15), backgroundColor: 'white', position: 'relative' }}>
      <MCVirtuoso
        model={galleryModel}
        data={items}
        components={{
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          ),
          Header: () =>
            hasMain && (
              <View style={{ gap: remCss(20), marginBottom: remCss(25) }}>
                <Splide>
                  {gallery.main.media.map((m, i) => (
                    <SplideSlide key={i}>
                      <FileBox
                        template={3}
                        list={gallery.main.media}
                        file={m}
                        onClose={null}
                        styles={{ width: '100%', height: remCss(300) }}
                        videoProps={{
                          width: '100%',
                          height: '100%'
                        }}
                        onlyPreview={true}
                        showFileName={false}
                      />
                    </SplideSlide>
                  ))}
                </Splide>
                <View style={{ gap: remCss(10) }}>
                  <MCText label={gallery.main.title} size={18} textLight />
                  <MCText label={gallery.main.description} size={20} weight={500} heading />
                </View>
                <View style={{ flexDirection: 'row', gap: remCss(10), flexWrap: 'wrap' }}>
                  {gallery?.tags.map((tag, index) => {
                    const active = galleryModel.state.tags?.find((t) => t === tag);
                    return (
                      <MCButton
                        primary
                        rounded
                        light
                        label={tag}
                        key={index}
                        dark={active}
                        onClick={() => {
                          galleryModel.setStateSilent({
                            tags: active
                              ? galleryModel.state.tags?.filter((t) => t !== tag)
                              : [...galleryModel.state.tags, tag]
                          });
                          galleryModel.refresh();
                        }}
                      />
                    );
                  })}
                </View>
              </View>
            )
        }}
        itemContent={(index, item) => {
          return (
            <View
              key={index}
              style={{
                gap: remCss(10),
                marginBottom: remCss(25),
                justifyContent: 'flex-start'
              }}
            >
              <View
                className={'mc-bg-primary-light'}
                style={{
                  width: remCss(54),
                  height: remCss(54),
                  textAlign: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%'
                }}
              >
                <MCText
                  primary
                  size={16}
                  weight={500}
                  lineHeight={18}
                  label={moment(item.date).format('MMM').toUpperCase()}
                />
                <MCText
                  primary
                  size={15}
                  lineHeight={18}
                  label={moment(item.date).format('YYYY')}
                />
              </View>
              <View
                style={{
                  flex: 1,
                  gap: remCss(20),
                  position: 'relative',
                  borderColor: scssVariables['colors-mc-border'],
                  borderWidth: 1,
                  borderRadius: remCss(10),
                  borderStyle: 'solid',
                  padding: remCss(20)
                }}
              >
                <View
                  style={{
                    position: 'absolute',
                    top: remCss(-10),
                    left: remCss(15),
                    backgroundColor: 'white',
                    transform: 'rotate(90deg)'
                  }}
                >
                  <SVGIcon
                    iconname={'arrow-icon'}
                    strokeWidth={0.5}
                    fill={scssVariables['colors-mc-border2']}
                  />
                </View>
                <MediaGroup images={item.media} template={6} length={2} aspect={3 / 4} />
                <View style={{ gap: remCss(10) }}>
                  <MCText label={item.title} size={18} textLight />
                  <MCText label={item.description} size={20} weight={500} heading />
                </View>
              </View>
            </View>
          );
        }}
      />
    </View>
  );
};
